import { showTyresAction, hideConfirmButtonAction } from '../../_flux/actions/rego_lookup_actions';

export function onShowTyres() {
    hideConfirmButtonAction();
    showTyresAction();
}
